import axiosPrivate from "./axiosPrivate";

export const getSolicitudes = () => {
    return axiosPrivate.get('/solicitud-viaticos');
};

export const insertSolicitud = (data) => {
    return axiosPrivate.post('/solicitud-viaticos', data);
};

export const updateSolicitud = (data) => {
    return axiosPrivate.put('/solicitud-viaticos', data);
};

export const deleteSolicitud = (data) => {
    return axiosPrivate.delete('/solicitud-viaticos', { data });
};

export const validarSolicitud = (data) => {
    return axiosPrivate.post('/solicitud-viaticos/validar', data);
};

export const getReporteSolicitudes = () => {
    return axiosPrivate.get('/solicitud-viaticos/reporte');
};
